import StandardTabPanel from "../../../../ui library/components/tab-panels/standard/StandardTabPanel";

export default function Navigation({ _case, activeTab, children }) {
  const allTabs = [
    {
      key: "details",
      name: "Client Info",
      isDisabled: false,
      permission: null,
      href: `/finance/cases/${_case.id}/details`,
    },
    {
      key: "expenses",
      name: "Expenses",
      isDisabled: false,
      permission: null,
      href: `/finance/cases/${_case.id}/expenses`,
    },
    {
      key: "payments",
      name: "Payments",
      isDisabled: false,
      permission: null,
      href: `/finance/cases/${_case.id}/payments`,
    },
    {
      key: "providers",
      name: "Providers",
      isDisabled: false,
      permission: null,
      href: `/finance/cases/${_case.id}/providers`,
    },
    {
      key: "documents",
      name: "Documents",
      isDisabled: false,
      permission: null,
      href: `/finance/cases/${_case.id}/documents`,
    },
  ];

  return (
    <StandardTabPanel activeTab={activeTab} tabList={allTabs}>
      {children}
    </StandardTabPanel>
  );
}
